try{self['workbox:sw:6.2.4']&&_()}catch(e){}// eslint-disable-line